import React from 'react';
import debounce from 'lodash/debounce';
import isUndefined from 'lodash/isUndefined';
import ReactGA from 'react-ga4';

import { withRouter, RouteComponentProps, Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import {
  datesActions,
  IFiltersState,
  IHotelsState,
  ILoginState,
  IMenuState,
  ISavedPropertiesState,
  ITrustYouReviewState,
  locationActions,
  markQuotesAsRead,
  resetHotelsFullWithParams,
  roomsActions,
} from '@share/store/slices';
import { getHotelDetails, getHotelStaticDetails, IHotelDetailsState, setError, setLoading } from '@store/slices';
import {
  getAccountUsernameFromPath,
  GetHomeParams,
  getNormalizedRooms,
  RootState,
  VACATIONS_PAGE,
} from '@share/utils';
import {
  ICertificateRouteHint,
  mergeHotelCertificateRouteHint,
  Responsive,
  UrlUtils,
  getHotelIdFromPath,
} from '@share/utils';
import {
  ALL_INCLUSIVE_KEY,
  D_VIEW_MAP_TEXT,
  DATES_LABEL,
  DEAL_HOME_LABEL,
  DEALID_LABEL,
  GETAWAYS_KEY,
  QUOTE_LABEL,
  ROOMS_LABEL,
  ROOMS_SEARCH_LABEL,
  SESSION_KEY_LABEL,
} from '@share/constants';
import {
  BookingErrorsEnum,
  GetawaysLocationEnum,
  IGeoLocation,
  IRoom,
  ISessionKey,
  IUrlRoom,
} from '@share/common-types';
import { Routes } from '@share/constants';
import {
  GeneralActivities,
  AdditionalDescription,
  MobileSlider,
  AvailabilityStatusModal,
  BigMap,
} from '@components';
import { IAnchor, IHotelDetailsParams, ILocation, IHotelDetails } from '@common-types';
import { CustomErrorPage } from '@share/components';
import { getRoomsDetails, roomsSearchActions } from '@store/slices';
import { LOCATION_OBJECT_LABEL, NULL_VALUE } from '@constants';
import { isQuintessVacationRental } from '@utils';

import { HotelInfo } from '../hotel-info';
import { HotelImagesDescription } from '../hotel-images-description';
import { QuintessImagesDescription } from '../quintess-images-description';
import { QuintessLocationTiles } from '../quintess-location-tiles';
import { Amenities } from '../amenities';
import { Policies } from '../policies';
import { Disclaimer } from '../disclaimer';
import { Location } from '../location';
import { SkeletonComponent } from '../skeleton';
import { RoomsSearch } from '../rooms-search';
import { HotelDetailsServerError } from '../hotel-details-server-error';
import { OtherImportantInformation } from '../other-important-information';
import { Reviews } from '../reviews';
import { HotelDetailsPriceChangeModal } from '../price-change-modal';
import { VacationRentalInfo } from '../vacation-rental-content/vacation-prop-info';
import { Activities } from '../vacation-rental-content/activities';

import './style.scss';
import { getLocationByCode } from '@share/services';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IMapStateToProps {
  hotelDetailsStore: IHotelDetailsState;
  trustYouReviewStore: ITrustYouReviewState;
  loginStore: ILoginState;
  hotelsStore: IHotelsState;
  menuStore: IMenuState;
  savedPropertiesStore: ISavedPropertiesState;
  filtersStore: IFiltersState;
}

interface IMapDispatchToProps {
  getRoomsDetails: (
    hotelId: number,
    sessionKey: ISessionKey | null | undefined,
    isFullLoading: boolean,
    certificateRoute?: ICertificateRouteHint,
  ) => void;
  getHotelDetails: (
    numberId: number,
    sessionKey: ISessionKey | undefined,
    dealId: number | undefined | null,
    quote: string | undefined | null,
    isStaticDetail: boolean | undefined | null,
    isRoomLoading?: boolean,
    certificateRoute?: ICertificateRouteHint,
  ) => void;
  getHotelStaticDetails: (numberId: number, isStaticDetail: boolean | undefined | null, skipRoomContent: boolean, onSuccess?: () => void) => void;
  setRooms: (roms: IRoom[]) => void;
  setDatesString: (dates: { startDate: string; endDate: string }) => void;
  resetHotelsFull: () => void;
  setError: (error: string) => void;
  setLoading: (loading: boolean) => void;
  
  markQuotesAsRead: (quoteId: string) => void;

  setSelectLocation: (location: ILocation) => void;
  setSelectLocationLabel: (label: string) => void;  
  setRoomsSearch: (rooms: IRoom[]) => void;
  setDatesSearch: (dates: { startDate: string; endDate: string }) => void;

  applyDates: () => void;
  applyRooms: () => void;
  applyLocation: () => void;

}

interface IParams {
  id: string;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, RouteComponentProps<IParams> {
  isVacationRentals: boolean;
  isStaticDetail?: boolean;
}

interface IState {
  active: number;
  isMapModalOpen: boolean;
  dealId: number;
  quote: string;
  backHomeType: string;
}

const ZERO = 0;
const DEFAULT_ANCHOR = 0;
const TAB_POLICIES = 'tab.policies';
const TAB_REVIEWS = 'tab.reviews';
const TAB_OTHER_IMPORTANT_INFO = 'other.important.information';
const TAB_ACTIVITY = 'tab.activity';
const TAB_GRAL_ACTIVITIES = 'tab.activities';
const TAB_AMENITIES = 'tab.amenities';
const TAB_OVERVIEW = 'tab.overview';
const TAB_ADDITIONAL_DESCRIPTION = 'additional.descriptions';
const DEBOUNCE_TIME = 100;

class HotelDetailsWrapperComponent extends React.Component<IProps, IState> {
  getCertificateRouteHint = (): ICertificateRouteHint | undefined => {
    return mergeHotelCertificateRouteHint(this.props.history.location.state, this.props.filtersStore);
  };

  getCertificateIdFromState = (): string | undefined => {
    return this.getCertificateRouteHint()?.certificateId;
  };
  state: IState = {
    active: DEFAULT_ANCHOR,
    isMapModalOpen: false,
    dealId: NULL_VALUE,
    quote: NULL_VALUE,
    backHomeType: NULL_VALUE,
  };

  overviewRef: React.RefObject<HTMLDivElement> = React.createRef();
  roomsRef: React.RefObject<HTMLDivElement> = React.createRef();
  amenitiesRef: React.RefObject<HTMLDivElement> = React.createRef();
  locationRef: React.RefObject<HTMLDivElement> = React.createRef();
  generalActivitiesRef: React.RefObject<HTMLDivElement> = React.createRef();
  activityRef: React.RefObject<HTMLDivElement> = React.createRef();
  policiesRef: React.RefObject<HTMLDivElement> = React.createRef();
  otherImportantRef: React.RefObject<HTMLDivElement> = React.createRef();
  reviewsRef: React.RefObject<HTMLDivElement> = React.createRef();
  additionalDescriptionRef: React.RefObject<HTMLDivElement> = React.createRef();

  ITEMS_ANCHOR: IAnchor[] = [
    { id: TAB_OVERVIEW, ref: this.overviewRef },
    { id: TAB_AMENITIES, ref: this.amenitiesRef },
    { id: 'location', ref: this.locationRef },
    { id: 'rooms', ref: this.roomsRef },
    { id: TAB_GRAL_ACTIVITIES, ref: this.generalActivitiesRef },
    { id: TAB_ACTIVITY, ref: this.activityRef },
    { id: 'tab.reviews', ref: this.reviewsRef },
    { id: TAB_ADDITIONAL_DESCRIPTION, ref: this.additionalDescriptionRef },
    { id: 'tab.policies', ref: this.policiesRef },
    { id: 'other.important.information', ref: this.otherImportantRef },
  ];
  scrollView = (e: React.MouseEvent<HTMLParagraphElement>, ref: React.RefObject<HTMLElement>) => {
    const index = e.currentTarget.dataset.index;
    if (index !== undefined) {
      this.setState({ active: +index });
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
    }
  };

  getAnchors = (): IAnchor[] => {
    const { hotel } = this.props.hotelDetailsStore;

    const allDataPolicies = [
      ...(hotel?.hotelDetails?.checkInInformation || []),
      ...(hotel?.hotelDetails?.checkOutInformation || []),
      ...(hotel?.hotelDetails?.pets || []),
    ];

    return this.ITEMS_ANCHOR.filter((item) => {
      if (
        (item.id === TAB_POLICIES && allDataPolicies.length === ZERO) ||
        (item.id === TAB_OTHER_IMPORTANT_INFO &&
          hotel?.hotelDetails?.otherImportantInformation.length === ZERO) ||
        (item.id === TAB_REVIEWS &&
          (!hotel?.hotelDetails?.guestRatings || hotel.hotelDetails?.isVacationRental)) ||
        (item.id === TAB_GRAL_ACTIVITIES &&
          (isUndefined(hotel?.hotelDetails?.activities) ||
            !hotel.hotelDetails?.isVacationRental ||
            hotel.hotelDetails?.activities?.length === 0)) ||
        (item.id === TAB_ACTIVITY &&
          (!hotel?.hotelDetails?.isVacationRental ||
            hotel.hotelDetails?.recreationalActivities?.length === 0)) ||
        (item.id === TAB_AMENITIES && hotel?.hotelDetails?.amenities?.length === ZERO) ||
        /*(item.id === TAB_OVERVIEW &&
          hotel?.roomsContent?.length !== 1 &&
          !hotel?.hotelDetails?.facilities &&
          !hotel?.hotelDetails?.specialInstructions &&
          !hotel?.hotelDetails?.other) ||*/
        (item.id === TAB_ADDITIONAL_DESCRIPTION &&
          hotel?.hotelDetails?.additionalDescriptions?.length === 0)
      ) {
        return;
      }
      return item;
    });
  };

  anchorLabelId = (id: string): string => {
    const { hotel } = this.props.hotelDetailsStore;

    if (id === 'rooms' && hotel?.hotelDetails?.isVacationRental) {
      return 'units';
    }

    // Whole-house stays state their check times in the entire-home panel, leaving
    // this section as the rules and whatever the panel does not cover.
    if (id === TAB_POLICIES && isQuintessVacationRental(hotel)) {
      return 'good.to.know';
    }

    return id;
  };

  filtersAnchor = () => {
    return this.getAnchors().map((itemAnchor: IAnchor, i: number) => (
      <p
        key={i}
        className={`hotel-details-wrapper__tab-anchors ${i === this.state.active ? 'active' : ''}`}
        onClick={(e) => this.scrollView(e, itemAnchor.ref)}
        data-index={i}
      >
        <FormattedMessage id={this.anchorLabelId(itemAnchor.id)} />
      </p>
    ));
  };

  onClickScrollToRooms = (e: React.MouseEvent<HTMLDivElement>) => {
    this.scrollView(e, this.roomsRef);
  };

  onClickScrollToReviews = (e: React.MouseEvent<HTMLDivElement>) => {
    this.scrollView(e, this.reviewsRef);
  };

  getDetailsData = (): IHotelDetailsParams => {
    const { search } = this.props.history.location;
    const checkIn = new URLSearchParams(search).get('checkIn') as string;
    const checkOut = new URLSearchParams(search).get('checkOut') as string;

    return { checkIn, checkOut };
  };

  async componentDidMount() {
    const values = UrlUtils.getValues();

    let dealId: number | undefined;
    if (values[DEALID_LABEL]) {
      dealId = parseInt(values[DEALID_LABEL] as string);
      this.setState({ dealId });
    }

    if (values[DEAL_HOME_LABEL]) {
      this.setState({ backHomeType: values[DEAL_HOME_LABEL] as string });
    }

    if (values[QUOTE_LABEL]) {
      this.props.markQuotesAsRead(values[QUOTE_LABEL] as string);
    }

    const { hotelsStore } = this.props;
    const { sessionKey } = hotelsStore;

    if (values[ROOMS_SEARCH_LABEL] && !this.props.isStaticDetail) {
      const { startDate, endDate, rooms } = values[ROOMS_SEARCH_LABEL] as {
        startDate: string;
        endDate: string;
        rooms: IUrlRoom[];
      };

      this.props.setDatesString({ startDate, endDate } as { startDate: string; endDate: string });
      this.props.setRooms(getNormalizedRooms(rooms));
      this.props.getRoomsDetails(
        getHotelIdFromPath(this.props.history),
        sessionKey,
        true,
        this.getCertificateRouteHint(),
      );
    } else {      
      if (this.props.isStaticDetail && !values[DATES_LABEL] && !values[ROOMS_LABEL]) {
        this.getHotelStaticDetails();
      } else {
        if (values[DATES_LABEL]) {
          this.props.setDatesString(values[DATES_LABEL] as { startDate: string; endDate: string });
          this.props.setDatesSearch(values[DATES_LABEL] as { startDate: string; endDate: string });
          this.props.applyDates();
        }
  
        if (values[ROOMS_LABEL]) {
          this.props.setRooms(getNormalizedRooms(values[ROOMS_LABEL] as Array<IUrlRoom>));
          this.props.setRoomsSearch(getNormalizedRooms(values[ROOMS_LABEL] as Array<IUrlRoom>));
          this.props.applyRooms();
        }
  
        if (!values[LOCATION_OBJECT_LABEL] && this.props.isStaticDetail) {
          const hotelId = getHotelIdFromPath(this.props.history);
          const location = await getLocationByCode(hotelId as number);
          this.props.setSelectLocationLabel(location?.data?.name);
          this.props.setSelectLocation(location?.data);
          this.props.applyLocation();
        }

        let quote;
        if (values[QUOTE_LABEL]) {
          quote = values[QUOTE_LABEL] as string;
          this.setState({ quote });
        }
  
        this.getHotelStaticDetails(dealId);
      }
      
    }
  }
  
  componentDidUpdate(prevProps: Readonly<IProps>): void {
    const { user } = this.props.loginStore;
    if (!prevProps.loginStore.user && !!user) {
      const values = UrlUtils.getValues();

      if (values[DEAL_HOME_LABEL]) {
        this.setState({ backHomeType: values[DEAL_HOME_LABEL] as string });
      }

      const dealId = values[DEALID_LABEL] ? parseInt(values[DEALID_LABEL] as string) : null;
      this.getHotelStaticDetails(dealId);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  getHotelDetails = (dealId: number | undefined | null) => {
    const { account, user } = this.props.loginStore;

    if (account && user) {
      const values = UrlUtils.getValues();
      const hotelId = getHotelIdFromPath(this.props.history);
      let quote;
      if (values[QUOTE_LABEL]) {
        quote = values[QUOTE_LABEL] as string;
      }
      this.props.getHotelDetails(
        hotelId,
        values[SESSION_KEY_LABEL] as ISessionKey,
        dealId,
        quote,
        this.props.isStaticDetail,
        true,
        this.getCertificateRouteHint(),
      );

      window.addEventListener('scroll', this.onScroll);
    }
  };

  getHotelStaticDetails = (dealId?: number | undefined | null) => {
    const { account, user } = this.props.loginStore;

    if (account && user) {
      const hotelId = getHotelIdFromPath(this.props.history);
      this.props.getHotelStaticDetails(hotelId, this.props.isStaticDetail, !this.props.isStaticDetail, () => {
        if (!this.props.isStaticDetail) {
          this.getHotelDetails(dealId);
        }
      });

      window.addEventListener('scroll', this.onScroll);
    }
  };

  getActiveAnchor = (): IAnchor => {
    const anchors: IAnchor[] = this.getAnchors();
    //const { pageYOffset } = window;
    const activeRef: IAnchor = anchors[this.state.active];

    // VERIFICAR
    // anchors.forEach((anchor: IAnchor) => {
    //   const { ref } = anchor;

    //   if (ref && ref.current) {
    //     const { current } = ref;
    //     const height = current.getBoundingClientRect()?.height;
    //     const offsetTop = current.offsetTop;
    //     const offsetBottom = offsetTop + height;

    //     if (height && offsetTop && pageYOffset >= offsetTop && pageYOffset <= offsetBottom) {
    //       activeRef = anchor;
    //     }
    //   }
    // });

    return activeRef;
  };

  onScroll = debounce(() => {
    const { hotel, loading } = this.props.hotelDetailsStore;

    if (hotel && !loading) {
      const anchor = this.getActiveAnchor();

      if (anchor && anchor.id) {
        const index = this.getAnchors().findIndex(({ id }) => id === anchor.id);

        if (index >= ZERO && this.state.active !== index) {
          this.setState({ active: index });
        }
      }
    }
  }, DEBOUNCE_TIME);

  showMap = () => {
    this.setState({ isMapModalOpen: true });
    document.body.style.overflow = 'hidden';

    const { loginStore } = this.props;
    const { account } = loginStore;

    ReactGA.event({
      category: account?.name as string,
      action: `${D_VIEW_MAP_TEXT}_${account?.name.toUpperCase()}`,
      label: `User clicked view map`,
      nonInteraction: false,
    });
  };

  closeMap = () => {
    this.setState({ isMapModalOpen: false });
    document.body.style.overflow = 'initial';
  };
  
  render(): React.ReactNode {
    const { isVacationRentals, isStaticDetail, loginStore, menuStore } = this.props;
    const { isMapModalOpen, dealId, backHomeType, quote } = this.state;
    const { hotel, loading, isServerError, error } = this.props.hotelDetailsStore;
    const { reviewModule } = this.props.trustYouReviewStore;
    const { account } = loginStore;
    const { items } = menuStore;

    const isAshevillePlay = account?.isAshevillePlay;

    const isVacation = hotel?.hotelDetails?.isVacationRental || false;
    const isQuintess = isQuintessVacationRental(hotel);
    const isAllInclusive = backHomeType === ALL_INCLUSIVE_KEY;

    const accountName = getAccountUsernameFromPath(this.props.history);
    const filterdImages = hotel?.hotelDetails?.images?.length
      ? hotel?.hotelDetails?.images.filter((i) => i?.width >= 400)
      : [];

    const backToList = (): string => {
      const isAllGetawayStorage = localStorage.getItem('isAllGetaway');
      const isAllGetaway = isAllGetawayStorage && JSON.parse(isAllGetawayStorage);

      if (isAllGetaway) {
        return `${Routes.Getaways}`;
      }
      return `${Routes.Getaway}/${GetawaysLocationEnum.Staycation}`;
    };
    
    return (
      <div className={`hotel-details-wrapper ${isAshevillePlay ? 'asheville-play-details-wrapper' : ''} ${isQuintess ? 'quintess-details-wrapper' : ''}`}>
        {isServerError ? (
          <HotelDetailsServerError isVacationRentals={isVacationRentals} />
        ) : (
          <>
            {!isAshevillePlay && (
              <div className="hotel-details-wrapper__back-link desktop">
                <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '5px' }} />
                {isVacationRentals ? (
                  <Link to={`/${accountName}${Routes.Search}/${VACATIONS_PAGE}${location.search}`}>
                    <FormattedMessage id="see.all.properties" />
                  </Link>
                ) : !!quote ? (
                  <Link to={`/${account?.name}${Routes.RsiQuotes}${location.search}`}>
                    <FormattedMessage id="back.to.quotes" />
                  </Link>
                ) : !dealId && !isAllInclusive && !this.props.isStaticDetail ? (
                  <Link to={`/${accountName}${Routes.Search}${location.search}`}>
                    <FormattedMessage id="see.all.properties" />
                  </Link>
                ) : !isEmpty(backHomeType) ? (
                  backHomeType === 'HOME' ? (
                    <Link to={`/${accountName}${Routes.Home}`}>
                      <FormattedMessage id="confirmation.go.back_home" />
                    </Link>
                  ) : !!quote ? (
                    <Link to={`/${account?.name}${Routes.RsiQuotes}${location.search}`}>
                      <FormattedMessage id="back.to.quotes" />
                    </Link>
                  ) : isAllInclusive ? (
                    !dealId ? (
                      <Link to={`/${accountName}${Routes.Search}${location.search}`}>
                        <FormattedMessage id="go.back.search" />
                      </Link>
                    ) : (
                      <Link
                        to={''}
                        onClick={() => {
                          const homeParams = GetHomeParams(account);
                          this.props.resetHotelsFull();
                          this.props.history.push(
                            `/${accountName}${Routes.AllInclusive}${homeParams}`,
                          );
                        }}
                      >
                        <FormattedMessage id="back.to.all_inclusive" />
                      </Link>
                    )
                  ) : (
                    <Link
                      to={''}
                      onClick={() => {
                        const homeParams = GetHomeParams(account);
                        this.props.resetHotelsFull();
                        this.props.history.push(`/${accountName}${Routes.Search}${homeParams}`);
                      }}
                    >
                      <FormattedMessage id="confirmation.go.back_home" />
                    </Link>
                  )
                ) : this.props.isStaticDetail && !dealId && !isAllInclusive ? (
                  <Link to={`/${accountName}${items?.showMyAccount ? Routes.SavedProperties : Routes.SavedPropertiesAccount}`}>
                    <FormattedMessage id="back.to.saved.properties" />
                  </Link>) : (
                  <Link to={`/${accountName}${backToList()}`}>
                    <FormattedMessage id="getaways.back" />
                  </Link>)}
              </div>)}

            {loading ? <SkeletonComponent isVacationRentals={isVacationRentals} /> : null}

            {!loading && hotel && isEmpty(error) ? (
              <>
                <div className={`hotel-details-wrapper__wrapper ${isAshevillePlay ? 'asheville-play-details' : ''} ${isQuintess ? 'quintess-details' : ''}`}>
                  {!isVacation && <div ref={this.overviewRef} />}

                  {isQuintess ? (
                    <QuintessImagesDescription
                      account={account}
                      images={filterdImages}
                      hotelName={hotel.hotelDetails?.title || ''}
                      hotelDescription={hotel.hotelDetails?.descriptions || []}
                      onClickScrollToRooms={this.onClickScrollToRooms}

                      showMap={this.showMap}
                      hotel={hotel.hotelDetails as IHotelDetails}
                      reviewModule={reviewModule}
                      roomsRef={this.roomsRef}
                      onClickScrollToReviews={this.onClickScrollToReviews}
                      filtersAnchor={this.filtersAnchor}

                      overviewRef={this.overviewRef}
                    />
                  ) : (
                    <HotelImagesDescription
                      account={account}
                      images={filterdImages}
                      hotelName={hotel.hotelDetails?.title || ''}
                      thumb={hotel.hotelDetails?.thumb}
                      hotelDescription={hotel.hotelDetails?.descriptions || []}
                      additionalDescriptions={hotel.hotelDetails?.additionalDescriptions || []}
                      hotelRooms={hotel.hotelDetails?.roomsCount || 0}
                      onClickScrollToRooms={this.onClickScrollToRooms}

                      showMap={this.showMap}
                      hotel={hotel.hotelDetails as IHotelDetails}
                      reviewModule={reviewModule}
                      roomsRef={this.roomsRef}
                      onClickScrollToReviews={this.onClickScrollToReviews}
                      filtersAnchor={this.filtersAnchor}

                      overviewRef={this.overviewRef}
                      isStaticDetail={isStaticDetail}
                    />
                  )}

                  {!isAshevillePlay && (
                    <div className="hotel-details-wrapper__back-link mobile">
                      <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '5px' }} />
                      {isVacationRentals ? (
                        <Link
                          to={`/${accountName}${Routes.Search}/${VACATIONS_PAGE}${location.search}`}
                        >
                          <FormattedMessage id="see.all.properties" />
                        </Link>
                      ) : !!quote ? (
                        <Link to={`/${account?.name}${Routes.RsiQuotes}${location.search}`}>
                          <FormattedMessage id="back.to.quotes" />
                        </Link>
                      ) : !dealId ? (
                        <Link to={`/${accountName}${Routes.Search}${location.search}`}>
                          <FormattedMessage id="see.all.properties" />
                        </Link>
                      ) : !isEmpty(backHomeType) ? (
                        backHomeType === 'HOME' ? (
                          <Link to={`/${accountName}${Routes.Home}`}>
                            <FormattedMessage id="confirmation.go.back_home" />
                          </Link>
                        ) : backHomeType === GETAWAYS_KEY ? (
                          <Link to={`/${accountName}${Routes.Getaways}`}>
                            <FormattedMessage id="getaways.back" />
                          </Link>
                        ) : (
                          <Link
                            to={''}
                            onClick={() => {
                              const homeParams = GetHomeParams(account);
                              this.props.resetHotelsFull();
                              this.props.history.push(`/${accountName}${Routes.Search}${homeParams}`);
                            }}
                          >
                            <FormattedMessage id="confirmation.go.back_home" />
                          </Link>
                        )
                      ) : (
                        <Link to={`/${accountName}${backToList()}`}>
                          <FormattedMessage id="getaways.back" />
                        </Link>
                      )}
                    </div>)}

                  {!isQuintess && (
                    <MobileSlider images={filterdImages} isAshevillePlay={isAshevillePlay} />
                  )}

                  <div className="hotel-details-wrapper__mobile-hotel-info">
                    <HotelInfo
                      hotel={hotel.hotelDetails as IHotelDetails}
                      showBigMap={this.showMap}
                      reviewModule={reviewModule}
                      roomsRef={this.roomsRef}
                      account={account}
                      onClickScrollToReviews={this.onClickScrollToReviews}
                    />
                  </div>

                  <div className="hotel-details-wrapper__amenities-location-wrapper">
                    {hotel.hotelDetails?.amenities.length ? (
                      <Amenities hotel={hotel.hotelDetails} refAnchor={this.amenitiesRef} />) : null}

                    <Location
                      hotel={hotel.hotelDetails as IHotelDetails}
                      location={hotel.hotelDetails?.location as IGeoLocation}
                      refAnchor={this.locationRef}
                      showBigMap={this.showMap}
                      isVacation={false}
                    />

                    {isQuintess && (
                      <QuintessLocationTiles
                        hotelDescription={hotel.hotelDetails?.descriptions || []}
                      />
                    )}
                  </div>

                  <Responsive>
                    <RoomsSearch
                      isVacationRentals={isVacationRentals}
                      isStaticDetail={isStaticDetail}
                      hotel={hotel}
                      refAnchor={this.roomsRef}
                      certificateRoute={this.getCertificateRouteHint()}
                    />
                  </Responsive>

                  {isVacation && (
                    <VacationRentalInfo
                      hotel={hotel.hotelDetails as IHotelDetails}
                      rooms={hotel.roomsContent}
                      isQuintess={isQuintess}
                    />
                  )}

                  {isVacation ? (
                    <>
                      {hotel.hotelDetails?.activities?.length ? (
                        <GeneralActivities
                          hotelDetail={hotel.hotelDetails}
                          refAnchor={this.generalActivitiesRef}
                        />
                      ) : null}
                      <Activities hotel={hotel.hotelDetails as IHotelDetails} refAnchor={this.activityRef} />
                    </>
                  ) : null}

                  {!isVacation && <Reviews hotel={hotel.hotelDetails as IHotelDetails} refAnchor={this.reviewsRef} />}

                  <AdditionalDescription
                    hotel={hotel.hotelDetails as IHotelDetails}
                    refAnchor={this.additionalDescriptionRef}
                  />

                  <Policies
                    hotel={hotel.hotelDetails as IHotelDetails}
                    refAnchor={this.policiesRef}
                    isQuintess={isQuintess}
                    room={hotel.roomsContent?.[ZERO]}
                  />

                  <OtherImportantInformation
                    hotel={hotel.hotelDetails as IHotelDetails}
                    refAnchor={this.otherImportantRef}
                  />

                  <Disclaimer accountName={accountName} />

                  <BigMap
                    title={hotel.hotelDetails?.title || ''}
                    isMapModalOpen={isMapModalOpen}
                    location={hotel.hotelDetails?.location as IGeoLocation}
                    onCloseMap={this.closeMap}
                  />
                </div>
              </>
            ) : null}
            {!loading && !isEmpty(error) ? (
              BookingErrorsEnum.RoomsUnavailable === error ? (
                <AvailabilityStatusModal isDetails isGetaways={!!dealId} />
              ) : (
                <CustomErrorPage message={error} />
              )
            ) : null}
          </>
        )}

        <HotelDetailsPriceChangeModal
          isDeal={!loading && !!dealId}
          isVacationRentals={isVacationRentals}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    hotelDetailsStore: state.hotelDetailsStore,
    trustYouReviewStore: state.trustYouReviewStore,
    loginStore: state.loginStore,
    menuStore: state.navigationMenuStore,
    hotelsStore: state.hotelsStore,
    savedPropertiesStore: state.savedPropertiesStore,
    filtersStore: state.filtersStore,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, undefined, Action>,
): IMapDispatchToProps => ({
  getHotelDetails: (
    numberId: number,
    sessionKey: ISessionKey | undefined | null,
    dealId: number | undefined | null,
    quote: string | undefined | null,
    isStaticDetail: boolean | undefined | null,
    isRoomLoading?: boolean,
    certificateRoute?: ICertificateRouteHint,
  ) => {
    dispatch(
      getHotelDetails(numberId, sessionKey, dealId, quote, isStaticDetail, isRoomLoading, undefined, certificateRoute),
    );
  },
  getHotelStaticDetails: (numberId: number, isStaticDetail: boolean | undefined | null, skipRoomContent: boolean = false, onSuccess?: () => void) => {
    dispatch(getHotelStaticDetails(numberId, isStaticDetail, skipRoomContent, onSuccess));
  },
  getRoomsDetails: (
    hotelId: number,
    sessionKey: ISessionKey | null | undefined,
    isFullLoading: boolean,
    certificateRoute?: ICertificateRouteHint,
  ) => {
    dispatch(getRoomsDetails(hotelId, sessionKey, isFullLoading, certificateRoute));
  },
  setRooms: (rooms: IRoom[]) => {
    dispatch(roomsSearchActions.setRooms(rooms));
  },
  setDatesString: (dates: { startDate: string; endDate: string }) => {
    dispatch(
      roomsSearchActions.setDates({
        startDate: dates.startDate,
        endDate: dates.endDate,
      }),
    );
  },
  resetHotelsFull: () => {
    dispatch(resetHotelsFullWithParams());
  },
  setError: (error: string) => {
    dispatch(setError(error));
  },
  setLoading: (loading: boolean) => {
    dispatch(setLoading(loading));
  },


  setSelectLocationLabel: (location: any) => {
    dispatch(locationActions.setSelectLocationLabel(location));
  },
  setSelectLocation: (location: any) => {
    dispatch(locationActions.setSelectLocation(location));
  },
  setRoomsSearch: (rooms: any) => {
    dispatch(roomsActions.setRooms(rooms));
  },
  setDatesSearch: (dates: any) => {
    dispatch(datesActions.setDatesSelected(dates));
  },
  applyDates: () => {
    dispatch(datesActions.applyDates());
  },
  applyRooms: () => {
    dispatch(roomsActions.applyRooms());
  },
  applyLocation: () => {
    dispatch(locationActions.applyLocation());
  },
  markQuotesAsRead: (quoteId: string) => {
    dispatch(markQuotesAsRead(quoteId));
  },

});

export const HotelDetailsWrapper = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(HotelDetailsWrapperComponent));
